import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import b2bApiClient from '@/shared/api/b2b-client'

export class MassPaymentsHistoryService {
  constructor() {
    this.client = b2bApiClient.getClient()
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  getHistory(params) {
    return this.client.get(
      '/payroll/mass-payments/history',
      params,
      this._headers
    )
  }

  downloadHistoryReport(id, params) {
    return this.client.client.get(
      `/payroll/mass-payments/${id}/history/download`,
      {
        params,
        headers: this._headers,
        responseType: 'blob',
      }
    )
  }
}

export default new MassPaymentsHistoryService()
